import React, { useState } from "react";
import styled, { css } from "styled-components";
import PopupContainer from "../../UI/PopupContainer";
import { InactiveIcon, ActiveIcon } from "./Icons";

const FootnoteContainer = styled.span<{ visible: boolean; screenHalf: string; width: number }>`
  display: ${({ visible }) => (visible ? "block" : "none")};
  position: absolute;
  top: 0;
  z-index: 1;
  min-width: 200px;
  width: ${({ width }) => (`${width}px`)};
  margin-top: 0;

  ${({ screenHalf = "left" }) =>
    screenHalf === "left"
      ? css`
          left: 0px;
        `
      : css`
          right: 0px;
        `};
`;

function findScreenHalf({
  target,
  clientX
}: {
  target: any;
  clientX?: number;
}) {
  const halfWindowWidth = window.innerWidth / 2;
  let xPosition;

  if (clientX) {
    xPosition = clientX;
  } else {
    const { left, width } = target.getBoundingClientRect();
    xPosition = left + width / 2;
  }

  return xPosition <= halfWindowWidth ? "left" : "right";
}

const Footnote: React.FC = ({ children }) => {
  const [visible, setVisibility] = useState(false);
  const [screenHalf, setScreenHalf] = useState("left");

  const showFootnote = (
    e:
      | React.MouseEvent<HTMLSpanElement>
      | React.KeyboardEvent<HTMLSpanElement>
      | React.FocusEvent<HTMLSpanElement>
  ) => {
    e.stopPropagation();
    setScreenHalf(findScreenHalf(e));
    setVisibility(true);
  };

  const hideFootnote = (
    e: React.MouseEvent<SVGElement> | React.FocusEvent<HTMLSpanElement>
  ) => {
    e.stopPropagation();
    setVisibility(false);
  };

  const onKeyDown = (e: React.KeyboardEvent<HTMLSpanElement>) => {
    if (e.keyCode === 13) {
      if (visible) {
        e.stopPropagation();
        setVisibility(false);
      } else {
        showFootnote(e);
      }
    }
  };

  const textColumnWidth = document.getElementById('current-chapter-col')?.offsetWidth ?? 0;
  const footnoteWidth = Math.min(Math.round(textColumnWidth * .75), 300); 

  return (
    <span
      role="button"
      style={{ outline: "none", position: "relative" }}
      tabIndex={0}
      onKeyDown={onKeyDown}
      onFocus={showFootnote}
      onBlur={hideFootnote}
      onClick={showFootnote}
    >
      <InactiveIcon />
      <FootnoteContainer
        visible={visible}
        screenHalf={screenHalf}
        width={footnoteWidth}>
        <ActiveIcon onClick={hideFootnote} side={screenHalf} />
        <PopupContainer onClick={e => e.stopPropagation()}>
          {children}
        </PopupContainer>
      </FootnoteContainer>
    </span>
  );
};

export default Footnote;
